import axios from 'axios';

const apiUrl = process.env.REACT_APP_SERVER_API_URL;

const paymentService = {
    // Create payment intent for cart items (without creating order)
    createCartPaymentIntent: async (cartItems, comments, promoCodeId = null) => {
        try {
            const response = await axios.post(`${apiUrl}/payment/cart/intent`, {
                items: cartItems,
                comments: comments,
                promoCodeId: promoCodeId
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Create payment intent for an order
    createPaymentIntent: async (orderId) => {
        try {
            const response = await axios.post(`${apiUrl}/orders/${orderId}/payment/intent`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Confirm payment completion
    confirmPayment: async (orderId, paymentIntentId) => {
        try {
            const response = await axios.post(`${apiUrl}/orders/${orderId}/payment/confirm`, {
                paymentIntentId
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Complete order after successful payment
    completeOrderAfterPayment: async (paymentIntentId, cartItems, comments, promoCodeId = null) => {
        try {
            const response = await axios.post(`${apiUrl}/payment/complete-order`, {
                paymentIntentId,
                items: cartItems,
                comments: comments,
                promoCodeId: promoCodeId
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get payment status
    getPaymentStatus: async (orderId) => {
        try {
            const response = await axios.get(`${apiUrl}/orders/${orderId}/payment/status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Create Pay Later order (manual payment)
    createPayLaterOrder: async (cartItems, comments, promoCodeId = null) => {
        try {
            const response = await axios.post(`${apiUrl}/payment/pay-later`, {
                items: cartItems,
                comments: comments,
                promoCodeId: promoCodeId
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default paymentService;